var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEuroOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a8cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#60acef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89c0ef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z",
    transform: "translate(80 80) rotate(180)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    transform: "translate(21.251 21.815)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.316,
    height: 38.316,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37.316,
    height: 37.316,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_currency-eur-off",
    "data-name": "Path / currency-eur-off",
    d: "M36.424,34.909,3.262,1.73,1.11,3.866l8.223,8.223a15.458,15.458,0,0,0-.841,1.867h-4.2L2.607,17.319H7.736L7.652,19l.084,1.682H4.288L2.607,24.045H8.492a15.179,15.179,0,0,0,14.294,10.09,14.7,14.7,0,0,0,6.928-1.682l4.574,4.591,2.136-2.136M11.015,19l.118-1.682H14.58l3.363,3.363H11.133L11.015,19M22.786,30.772a11.784,11.784,0,0,1-10.645-6.727h9.165l5.852,5.886a12.184,12.184,0,0,1-4.372.841m5.045-8.728L26.5,20.682H28.42l-.589,1.362m2-4.725H23.139l-3.363-3.363H31.262l-1.429,3.363M15.555,9.751l-2.4-2.4A15.072,15.072,0,0,1,33.6,8.44L32.153,11.87a11.712,11.712,0,0,0-16.6-2.119Z",
    transform: "translate(21.45 21.677)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroOff);
export default __webpack_public_path__ + "static/media/euro-off.21aaeae05dbe4b07645bcf4a09019a74.svg";
export { ForwardRef as ReactComponent };